/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto}[_nghost-%COMP%]   mat-card[_ngcontent-%COMP%]{margin-left:40px;margin-right:40px;margin-bottom:20px}fieldset[_ngcontent-%COMP%]{margin-top:1em;margin-bottom:1em;border-color:#d3d3d3;border-width:thin;border-style:solid}"];
export { styles as styles };
